import { components } from "@/_apiSchema.ts";
import { isObjectOf } from "@/core/utils/objects.ts";
import { isBoolean, isString } from "@/core/utils/types.ts";

export type TBfitIdTypeDTO = components["schemas"]["BfitIdTypeDTO"];
export type TIdTypeDTO = components["schemas"]["IdTypeDTO"];
export type TBooleanWrapperDTO = components["schemas"]["BooleanWrapperDTO"];
export type TIdWrapperDTO = components["schemas"]["IdWrapperDTO"];
export type TReportIdWrapperDTO = components["schemas"]["ReportIdWrapperDTO"];
export type TReportDTO = components["schemas"]["ReportDTO"];

export function isBooleanWrapperDTO<T = TBooleanWrapperDTO>(object: unknown): object is T {
    return isObjectOf<T>(object, {
        message: "Content is not of type TBooleanWrapperDTO",
        fn: (object) => isBoolean(object["value"]),
    });
}

export function isReportIdWrapperDTO<T = TReportIdWrapperDTO>(object: unknown): object is T {
    return isObjectOf<T>(object, {
        message: "Content is not of type TReportIdWrapperDTO",
        fn: (object) => isString(object["id"]),
    });
}
